import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { g } from "@/lib/api";
import { useI18n } from "@/i18n";
import { useApp } from "@/context/AppContext";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";
import { CheckCircle2, Circle, ArrowRight } from "lucide-react";

/** Primi passi: quattro cose da fare, spuntate da sole guardando cosa è già stato fatto nel locale. */
export const PrimiPassi = () => {
  const { t } = useI18n();
  const { showcase } = useApp();
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [hidden, setHidden] = useState(() => !!localStorage.getItem("rh_steps_hidden"));

  useEffect(() => {
    g("/onboarding/steps").then(setD).catch(() => setD(null));
  }, []);

  const done = (d?.steps || []).filter((s) => s.done).length;
  if (!d || hidden || done === 4) return null;

  return (
    <Card className="p-6" data-testid="primi-passi">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-lg font-semibold">{t("ob.title")}</h3>
          <p className="mt-1 text-sm text-slate-500">{t("ob.sub", { n: done })}</p>
        </div>
        <button
          className="shrink-0 text-xs font-semibold text-slate-400"
          data-testid="primi-passi-hide"
          onClick={() => {
            localStorage.setItem("rh_steps_hidden", "1");
            setHidden(true);
          }}
        >
          {t("ob.hide")}
        </button>
      </div>

      <div className="mt-4 h-1.5 overflow-hidden rounded-full bg-slate-100">
        <div className="h-full bg-emerald-500 transition-all" style={{ width: `${(done / 4) * 100}%` }} />
      </div>

      <div className="mt-4 space-y-2">
        {d.steps.map((s, i) => (
          <button
            key={s.id}
            onClick={() => !s.done && nav(s.to)}
            data-testid={`ob-step-${s.id}`}
            className={cn("flex w-full items-center gap-3 rounded-lg border p-3 text-left transition-colors",
              s.done ? "border-emerald-200 bg-emerald-50" : "border-slate-200 hover:bg-slate-50")}
          >
            {s.done
              ? <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-600" />
              : <Circle className="h-5 w-5 shrink-0 text-slate-300" />}
            <span className={cn("min-w-0 flex-1 text-sm", s.done ? "text-emerald-900 line-through" : "font-semibold")}>
              {i + 1}. {t(`ob.step.${s.id}`)}
            </span>
            {!s.done && <ArrowRight className="h-4 w-4 shrink-0 text-slate-400" />}
          </button>
        ))}
      </div>

      <p className="mt-4 text-xs text-slate-500">{showcase ? t("ob.helpDemo") : t("ob.help")}</p>
    </Card>
  );
};
